const ResumeCard = ({
  eduTitle,
  year,
  schoolName,
  subTitle,
  skills,
}) => {
  return (
    <div className="education-container">
      <div className="resume-item">
        <h4>{eduTitle}</h4>
        <h5>{year}</h5>
        <p className="school-name">
          <em>{schoolName}</em>
        </p>
        <p className="subtitle">
          <em>{subTitle}</em>
        </p>
          <ul>
            {skills.map((skill, i) => (
              <li key={i}>{skill}</li>
            ))}
          </ul>
      </div>
    </div>
  );
};

export default ResumeCard;
